<template>
  <div class="nav">
    <img src="../assets/nav/yz_nav_fh.png" class="fh" @click="$router.back()">
    <h3>{{title}}</h3>
    <div class="right-nr">
      <div v-if="textright" class="text" @click="clickRight">{{textright}}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {
    reactive
  } from "vue";
  import {
    useRouter
  } from "vue-router";

  export default {
    props: ["title","textright"],
    setup(props, context) {
      console.log(props)
      const router = useRouter();
      const state = reactive({
      });
      const clickRight=()=>{
        context.emit("clickRight");
      }
      const goGamedetails = (id, h5) => {
        if (h5 == "1") {
          router.push({
            path: "/gamedetails",
            query: {
              gid: id,
              edition: "3"
            }
          });
        } else {
          router.push({
            path: "/gamedetails",
            query: {
              gid: id,
              edition: "0"
            }
          });
        }
      };
      return {
        state,
        clickRight,
        goGamedetails,
      };
    },
  };
</script>

<style scoped="scoped">
  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px;
    padding-top: calc(32px + constant(safe-area-inset-top));
    /* 适配安全区域 iOS < 11.2 */
    padding-top: calc(32px + env(safe-area-inset-top));
    /* 适配安全区域 iOS >= 11.2 */
    position: relative;
  }

  .nav .fh {
    width: 60px;
    height: 60px;
    margin-right: 32px;
  }
  .nav h3{
    font-size: 32px;
    color: #333;
    width: 500px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    position: absolute;
    left: 50%;
    margin-left: -250px;
    top: 50%;
    margin-top: -30px;
  }
  .nav .right-nr .text{
    font-size: 24px;
    color: #664FC3;
  }
</style>